import React from "react";
import commonStyles from "@styles/CommonEditorPageLayout.module.css";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Button from "@components/buttons/Button/Button";
import styles from "./InviteDirectorSuccessPage.module.css";

const InviteDirectorSuccessPage: React.FC = () => {
    const navigate = useNavigate();

    const handleFinish = () => {
        navigate("/users");
    };

    return (
        <div className={commonStyles.container}>
            <h2>Invitation Sent</h2>
            <div className={commonStyles.messageContainer}>
                <div className={styles.checkIcon}>
                    <CheckCircleOutlineIcon fontSize="inherit" />
                </div>
                <p>An invitation email will be sent.</p>
                <p>User must accept the invitation to manage funeral notices and memorials.</p>
                <div className={styles.buttonContainer}>
                    <Button onClick={handleFinish}>Finish</Button>
                </div>
            </div>
        </div>
    );
};

export default InviteDirectorSuccessPage;
